// eslint-disable-next-line angular/no-service-method
angular.
module("digiexam.exam").
service("ExamDraftRepository", function examDraftRepositoryService(
	$http,

	Exam
) {
	"use strict";

	// eslint-disable-next-line consistent-this
	var repo = this;

	repo.load = function load(id) {
		return $http.get("/draft/Exam/" + id).then(function success(response) {
			var draftResponse = response.data;

			if (!draftResponse || !draftResponse.data || draftResponse.data.length === 0) {
				return null;
			}

			var draft = JSON.parse(draftResponse.data);
			return {
				examDraft: new Exam(draft),
				lastModified: draftResponse.modified,
			};
		});
	};

	repo.save = function save(id, draft) {
		var data;

		if (typeof draft === "string") {
			data = draft;
		} else {
			data = JSON.stringify(draft);
		}

		var saveRequestData = {
			type: "Exam",
			objectId: typeof id === "string" ? parseInt(id, 10) : id,
			data: data,
		};

		return $http.post("/draft/save/", saveRequestData).then(function success(response) {
			return new Exam(response.data);
		});
	};

	repo.clear = function clear(id) {
		return repo.save(id, "");
	};
});
